export default "__VITE_ASSET__940fe920__"